import { TextField } from "@mui/material";
import { QuestionSlice } from "../../../Redux/reducers/responseSlice";

type Props = {
  currentQuestion: QuestionSlice;
};

const CalculatedFieldPreview = ({ currentQuestion }: Props) => {
  return (
    <div className="simple-preview-wrapper">
      <TextField
        name="textValue"
        fullWidth
        placeholder=""
        InputProps={{
          readOnly: true,
        }}
      />
    </div>
  );
};
export default CalculatedFieldPreview;
